import styled from 'styled-components';
import BaseVehicleIcon from '#/shared/components/VehicleIcon';
import VehicleRays from '#/images/svg/perspective-stripe.svg';
import {
  XLDESKTOP_BREAK,
  DESKTOP_MIN_BREAK,
  TABLET_BREAK,
} from '#/shared/constants';

export const VehicleIcon = styled(BaseVehicleIcon).attrs({
  width: '100%',
  height: '100%',
})`
  filter: drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.5));
`;

export const BrandFooterWrap = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  background-color: ${props =>
    props.inverse
      ? props.theme.backgroundColor
      : props.theme.inverseBackgroundColor2};

  /* adjusting for unique ipad pro devices */
  @media only screen and (min-device-width: ${TABLET_BREAK}) and (max-device-width: 1023px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
    padding: 0 5em;
  }
`;
export const BrandFooter = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;

  align-content: flex-end;
  background-image: url('${VehicleRays}');
  background-repeat: no-repeat;
  background-position: center bottom;
`;

export const VehicleIconsRow = styled.div`
  display: flex;
  flex: 1;
  max-width: 60%;
  @media (min-width: ${TABLET_BREAK}) {
    max-width: 50%;
  }
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    max-width: 55%;
  }
  @media (min-width: ${XLDESKTOP_BREAK}) {
    max-width: 60%;
  }
  align-self: center;
`;
export const LogoRow = styled.div`
  display: flex;
  margin: 5px 0 10px;
  max-width: 150px;
  align-self: center;
`;

export const VehicleCol = styled.div`
  display: flex;
  flex: 1 0 100px;
  align-self: flex-end;
  margin: 0 -15%;
  &:first-child {
    z-index: 6;
  }
  &:nth-child(2) {
    z-index: 5;
  }
  &:nth-child(3) {
    z-index: 4;
  }
`;
